<template>
  <div class="ask-show-comment">
    <div class="comment" v-if="info">
      <van-row class="list" gutter="15">
         <!-- @click="goMy(info.user.id)" -->
        <van-col span="3">
          <img class="avatar" :src="info.user && info.user.headimg_url&&info.user.headimg_url.substring(0,5)=='https' ? info.user.headimg_url : img.avatar" />
        </van-col>
        <van-col span="21">
          <h3>
            {{ info.user.user_name }}
            <span class="binbox">
              <img class="binpic" :src="img.collect">
              <span class="sourtime">30</span>
            </span>
          </h3>
          <p v-if="info.content">{{ info.content }}</p>
          <p class="time">{{ info.create_time }}
            <span class="c-black" @click="replysOne()"> · 回复({{ info.reply_num }})</span>
            <span v-if="info.user.id==params.user_id" class="f-r" @click="delComment(info.id)">删除</span>
            <span v-else class="f-r" @click="toTip">举报</span>
          </p>
        </van-col>
      </van-row>
    </div>
    <div class="replys">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已加载全部"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="img.loading" />
      </div>
      <div class="reply">
        <van-row class="list" gutter="15" v-for="reply in replys" :key="'reply_' + reply.id">
          <!-- @click="goMy(reply.user.id)" -->
          <van-col span="3">
            <img class="avatar" :src="reply.user && reply.user.headimg_url&&reply.user.headimg_url.substring(0,5)=='https' ? reply.user.headimg_url : img.avatar" />
            
          </van-col>
          <van-col span="21">
             <!-- @click="goMy(reply.user.id)" -->
            <h3>
              {{ reply.user.user_name }}
            </h3>
            <p v-if="reply.content"><span v-if="reply.reuser">回复<span class="f-w ml-5">{{ reply.reuser.user_name }}</span>：</span>{{ reply.content }}</p>
            <p class="time">{{ reply.create_time }}
              <span class="c-black" @click="replysTow(reply.id)"> · 回复
                <span v-if="reply.reply_num>0">({{ reply.reply_num }})</span>
              </span>
            </p>
          </van-col>
        </van-row>
      </div>
    </van-list>
  </div>
  <div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
  <div class="postbottom" id="inputid">
    <van-row>
      <van-col :span="inputnum">
        <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
      </van-col>
      <van-col  v-if="inputshow" class="botright" span="10">
        <van-row>
          <van-col span="8"> 
            <span class="binbox">
              <img class="binpic" :src="img.comment">
              <span class="num" v-if="info.reply_num>0">{{info.reply_num}}</span>
            </span>
          </van-col>
          <van-col span="10">
            <span class="binbox" @click="Collect(info.is_collect)">
              <img class="binpic" :src="info.is_collect==1?img.collect_have:img.collect">
              <span class="num" v-if="info.collect>0">{{info.collect}}</span>
            </span>
          </van-col>
          <van-col span="6">
            <span class="binbox" @click="outrelay()">
              <img class="binpic" :src="img.outrelay">
            </span>
          </van-col>
        </van-row>
      </van-col>
      <van-col v-else span="5">
        <van-button color="#605C6B" size="small" @click="post()">发表</van-button>
      </van-col>
    </van-row>
  </div>
  <van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
    <van-divider class="divider">分享</van-divider>
    <van-grid :border='false' :column-num="5">
      <!-- <van-grid-item :icon="img.inrelay" /> -->
      <van-grid-item :icon="img.friends" @click="toShare(2)" />
      <van-grid-item :icon="img.wechat" @click="toShare(1)" />
      <!-- <van-grid-item :icon="img.link" />
        <van-grid-item :icon="img.poster" /> -->
      </van-grid>
    </van-action-sheet>
  </div>
</template>
<script>
  import active from '../../../api/lexus/active';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {List, Row, Col,Field,Button,Overlay,ActionSheet,Divider,Grid,GridItem} from "vant";

  export default {
    data () {
      return {
       value:'',
       inputshow:true,
       overlay:false,
       inputfocus:false,
       inputnum:14,
       rid:'',
       replytype:0,
       params: {
        page: 1,
        size: 4,
        order: 1,
        user_id: 0
      },
      comment_id: 0,
      loading: false,
      finished: false,
      info: '',
      replys: [],
      shareshow:false,
      img: {
        avatar: require('../../../assets/img/lexus/default.png'),
        parise: require('../../../assets/img/parise.png'),
        parise_have: require('../../../assets/img/parise_have.png'),
        loading: require('../../../assets/img/loading_lexus.gif'),
        collect: require('../../../assets/img/lexus/collect.png'),
        collect_have: require('../../../assets/img/lexus/collect_have.png'),
        comment: require('../../../assets/img/lexus/comment.png'),
        inrelay: require('../../../assets/img/lexus/inrelay.png'),
        outrelay: require('../../../assets/img/lexus/outrelay.png'),
        friends: require('../../../assets/img/lexus/friends.png'),
        wechat: require('../../../assets/img/lexus/wechat.png'),
        link: require('../../../assets/img/lexus/link.png'),
        poster: require('../../../assets/img/lexus/poster.png'),
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    let id = this.$route.params.id
    this.hid=this.$route.params.hid
    this.weburl=process.env.VUE_APP_URL
    if(this.$util.isEmpty(id)) {
      this.$toast('评论不存在')
      return false
    }
    this.comment_id = id

    this.getInfo()
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  watch: {
    '$route'() {
      if(this.$route.params.id != this.comment_id) {
        this.comment_id = this.$route.params.id
        this.getInfo()
      }
    }
  },
  methods: {
    setCommentPraise () {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.info.is_praise ? 2 : 1;
        active.setCommentPraise({id: this.info.id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.info.is_praise = 1
            } else {
              this.info.is_praise = 0
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }

    },
    setReplyPraise (index) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.replys[index].is_praise ? 2 : 1;
        active.setCommentPraise({id: this.replys[index].id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.replys[index].is_praise = 1
              this.replys[index].praise_num += 1
            } else {
              this.replys[index].is_praise = 0
              this.replys[index].praise_num -= 1
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }

    },
    toTip() {
      this.$toast.success('举报成功')
    },
    getActive () {
      let user_id = this.user ? this.user.id : 0
      ask.getAnswerShow(this.answer_id, {user_id: user_id}).then(res => {
        if(res.data.state == 1) {
          this.aninfo = res.data.data
        }
      })
    },
    getInfo () {
      let user_id = this.user ? this.user.id : 0
      active.getCommentShow(this.comment_id, {user_id: user_id}).then(res => {
        if(res.data.state == 1) {
          this.info = res.data.data
        }
      })
    },
    inputFocus(){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      this.inputshow=false;
      this.rid=this.comment_id
      this.replytype=0
      this.overlay=true;
      this.inputnum=19;
      setTimeout(() => {
        var cc=document.getElementById('inputid');
        cc.scrollIntoViewIfNeeded(true);
      },500);
    },
    inputBlur(){
      setTimeout(() => {
        this.inputshow=true;
        this.inputnum=14;
      }, 1000);
      this.overlay=false;
      this.inputfocus=false
    },
    replysTow(rid){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      this.inputshow=false;
      this.rid=rid
      this.replytype=1
      this.$refs.inputTag.focus()
      this.overlay=true;
      this.inputnum=19;
      this.inputfocus=true
      setTimeout(() => {
        var cc=document.getElementById('inputid');
        cc.scrollIntoViewIfNeeded(true);
      },500);
    },
    replysOne(){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      this.inputshow=false;
      this.rid=this.comment_id
      this.replytype=0
      this.$refs.inputTag.focus()
      this.overlay=true;
      this.inputnum=19;
      this.inputfocus=true
      setTimeout(() => {
        var cc=document.getElementById('inputid');
        cc.scrollIntoViewIfNeeded(true);
      },500);
    },
    touchstart(){//检测触发遮罩层，失去焦点
      this.inputshow=true;
      this.overlay=false;
      this.$refs.inputTag.blur()
      this.inputnum=14;
      this.inputfocus=false
      this.replytype=0
    },
    post(){
      if(this.replytype==0){
        var params={
          parent_rid:'',
          rid:this.rid,
          hid:this.hid,
          content:this.value
        }
      }else{
        var params={
          parent_rid:this.comment_id,
          rid:this.rid,
          hid:this.hid,
          content:this.value
        }
      }
      active.Comment(params).then(res => {
       if(res.data.state == 1) {
        this.inputshow=true;
        this.inputnum=14;
        this.overlay=false;
        this.inputfocus=false
        this.$refs.inputTag.blur()
        this.replytype=0
        this.$toast.success('发表成功')
        this.value=''
        this.finished = false
        this.replys=[]
        this.params.page = 1
      }
    })
    },
    delComment(id,index){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      this.$dialog.confirm({
        message: '确定要删除吗？'
      }).then(() => {
        content.delComment(id).then(res => {
          if(res.data.state == 1) {
            this.$toast.success('已删除')
            setTimeout(() => {
              this.$router.go(-1)
            }, 1500);
          }
        })
      }).catch(() => {});
    },
    onCancel(){
      this.actionshow=false
    },
    outrelay(){
      this.shareshow=true
      this.sharetitle=this.aninfo.question
      this.sharecontent=this.aninfo.content
      this.shareurl=this.weburl+'/lexus/ask/'+this.aninfo.answer.id+'/answer'
      if(this.aninfo.image[0]){
        this.shareimageUrl=this.aninfo.image[0]
      }else{
        this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
      }

    },
    toShare(type){
      var params={
        type:type,
        title:this.sharetitle,
        content:this.sharecontent,
        url:this.shareurl,
        imageUrl:this.shareimageUrl
      }
      this.shareshow=false
      this.$appService.shareContent(params)
    },
    goMy(id){
      var params={
        url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
        isReturn: true 
      }
      this.$appService.openWebView(params)
    },
    onLoad() {
      this.params.user_id = this.user ? this.user.id : 0
      // 异步更新数据
      setTimeout(() => {
        active.getCommentReplys(this.comment_id, this.params).then(res => {
          this.replys.push.apply(this.replys, res.data.data.data)
          this.params.page += 1
          this.loading = false

          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      }, 1000);
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [List.name]: List,
    [Field.name]:Field,
    [Button.name]:Button,
    [Overlay.name]:Overlay,
    [Divider.name]:Divider,
    [Grid.name]:Grid,
    [GridItem.name]:GridItem,
    [ActionSheet.name]:ActionSheet
  }
};
</script>

<style lang="scss">
.ask-show-comment {
  .comment{
    border-bottom: 1px solid #EAEAEA;
    padding: 15px;
  }
  .replys {
    margin-top: 10px;
    padding: 0 15px;
    .reply {
      overflow: hidden;
      .ml-5{
        margin-left: 5px;
      }
    }
    
  }
  .sourtime{
    font-size: 12px;
    color: #9A9A9A;
  }
  .list {
    padding: 10px 0;
  }
  .avatar {
   width: 40px;
   height: 40px;
   object-fit: cover;
   border-radius: 1.5px;
 }
 h3 {
  font-size: 15px;
  margin: 8px 0;

  .binbox {
    color: #9A9A9A;
    font-size: 12px;
    float: right;
    font-weight: normal;
    img {
      width: 15px;
      height: 14px;
      margin-right: 11px;
    }
  }
}
p {
  font-size: 15px;

  .c-blue {
    font-style: normal;
  }
}
.time {
  font-size: 12px;
  color: #9A9A9A;
}
.bintright {
  text-align:right;
}
a{
  color: #3A3A3A;
}
.van-popup{
  .van-action-sheet__cancel::before{
    height: 1px;
  }
  .divider{
    margin: 20px 80px;
  }
}
}
</style>
